import React from 'react';
import PageContentWrapper from '../../components/PageContentWrapper/PageContentWrapper';
import CardContainer from '../../components/CardContainer/CardContainer';
import { useMediaQuery } from 'src/hooks/useMediaQuery';
import { clsx } from 'clsx';
import { useParams } from 'react-router-dom';
import { useGetProjectByIdQuery } from 'src/services';
import { AddIntegrationPopup } from 'src/components/Integrations/AddIntegrationPopup/AddIntegrationPopup';
import { IntegrationsList } from 'src/components/Integrations/IntegrationsList/IntegrationsList';
import { ProductsType } from 'src/constants/products';
import {
  IntegrationTypeAgent,
  IntegrationTypeBi,
  IntegrationTypeCustomer,
} from 'src/components/Integrations/IntegrationTypes';
import { useAppSelector } from 'src/store';

const IntegrationsPage = () => {
  const isLgDown = useMediaQuery('(max-width: 992px)');
  const { id } = useParams();
  const { projectType } = useAppSelector((s) => s.projectsSlices);
  const { data: currentProject, isFetching: isFetchingProject } = useGetProjectByIdQuery({
    id: id,
  });
  const integrationTypes =
    ((projectType as string) === ProductsType.agent && IntegrationTypeAgent) ||
    ((projectType as string) === ProductsType.customer && IntegrationTypeCustomer) ||
    ((projectType as string) === ProductsType.bi && IntegrationTypeBi);

  const isAddIntegrationAvailable =
    (integrationTypes &&
      (integrationTypes as any).filter(
        (type) =>
          !(currentProject as any)?.integrations.some(
            (integration) => integration.integration_type === type.data.integration_type,
          ),
      ).length) ||
    null;

  return (
    <React.Fragment>
      <PageContentWrapper
        className={clsx('knowledge-base-page-container', !isLgDown && 'relative')}
        isMobileMarginTop={false}
        projectBreadcrumbsContent={'Integrations'}
      >
        <div className="z-10 gap-[10px] flex flex-col relative">
          <CardContainer className="integration">
            <div className="card-header">
              <div className="title">
                <span>Integrations</span>
              </div>
              <div className="add-button-container">
                {currentProject && isAddIntegrationAvailable && (
                  <AddIntegrationPopup project={currentProject} />
                )}
              </div>
            </div>
            <div className="card-body">
              <IntegrationsList
                isFetchingProject={isFetchingProject}
                isEmpty={!(currentProject as any)?.integrations?.length}
                integrations={(currentProject as any)?.integrations}
                integrationTypes={integrationTypes}
              />
            </div>
          </CardContainer>
        </div>
      </PageContentWrapper>
    </React.Fragment>
  );
};

export default IntegrationsPage;
